import { api } from './api';

// The Founder's Access Levels screen (backend AccessLevelController).
export const accessLevelsApi = {
    // Any member: shows a member's level by name.
    options: () => api.get('/access-levels/options').then((res) => res.data),
    list: () => api.get('/access-levels').then((res) => res.data),
    catalog: () => api.get('/access-levels/catalog').then((res) => res.data),
    // Active members with no usable level (behind access.manage).
    unassigned: () => api.get('/access-levels/unassigned').then((res) => res.data),
    create: (level) => api.post('/access-levels', level).then((res) => res.data),
    update: (id, changes) => api.patch('/access-levels/' + id, changes).then((res) => res.data),
    remove: (id) => api.del('/access-levels/' + id),
};
